export enum EMovimentoFinanceiroBaixaReferente
{
    BaixaTitulo = 1,
    JurosMulta = 2,
    Desconto = 3,
    Acrescimo = 4,
    Taxa = 5,
    Abatimento = 6
}
